var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg038Target = function Svg038Target(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#038-target_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17a6.262 6.262 0 0 1 4.375-5.962A6.258 6.258 0 0 0 8.75 17a6.258 6.258 0 0 0 8.125 5.962A6.262 6.262 0 0 1 12.5 17Z",
    fill: "#A0EDA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.809.132a1.25 1.25 0 0 1 .559 1.677l-.823 1.646 1.646-.823a1.25 1.25 0 1 1 1.118 2.236l-4.819 2.41-10.606 10.606a1.25 1.25 0 1 1-1.768-1.768L24.723 5.51 27.132.69a1.25 1.25 0 0 1 1.677-.559Z",
    fill: "#005454"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.5C8.096 4.5 2.5 10.096 2.5 17S8.096 29.5 15 29.5 27.5 23.904 27.5 17c0-1.789-.375-3.487-1.05-5.022a1.25 1.25 0 0 1 2.29-1.005A14.953 14.953 0 0 1 30 17c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 8.716 6.716 2 15 2c2.142 0 4.181.45 6.027 1.26a1.25 1.25 0 0 1-1.005 2.29A12.453 12.453 0 0 0 15 4.5Z",
    fill: "#14D64D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-7.5 5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z",
    fill: "#005454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "038-target_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};

export default Svg038Target;